export default __webpack_public_path__ + "static/media/win-cloudos.b386173e.jpg";